import React from "react";

import { showDialogAsync } from "../../dialog-queue";
import { AlertDialog } from "../../dialog/alert";
import { labels } from "./labels";

export const showErrorDialogAsync = ({
	errorMessageLabel,
}: {
	errorMessageLabel?: eXpress.creator.LabelRequest;
}) =>
	showDialogAsync<boolean>(({ resolve }, { isOpen }) => (
		<AlertDialog
			titleLabel={labels.title}
			messageLabel={errorMessageLabel || labels.message}
			isOpen={isOpen}
			okLabel={labels.close}
			onOk={() => resolve(true)}
		/>
	));
